import { getLawInterfaceFromStorage } from 'CorePackage/MainModule/common/getLawInterfaceFromStorage';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';

import { APIServiceEnum } from '../enums/APIServiceEnum';

export function getServiceBaseURL(service: APIServiceEnum, isErp?: boolean): string {
  let isErknm: boolean = getLawInterfaceFromStorage() === LawInterfacesEnum.FZ_248;

  if (typeof isErp === 'boolean') {
    isErknm = !isErp;
  }
  switch (service) {
    case APIServiceEnum.KNM_SERVICE:
      return isErknm ? '/erknm-knm/api' : '/knm-service/api';
    case APIServiceEnum.BASE_SERVICE:
      return isErknm ? '/erknm-catalogs/api' : '/private/api';
    case APIServiceEnum.INDEX_SERVICE:
      return isErknm ? '/erknm-index/api' : '/private/api';
    case APIServiceEnum.LK_SERVICE:
      return '/erknm-catalogs/api';
    case APIServiceEnum.ANALYTIC_SERVICE:
      return isErknm ? '/erknm-analytics/api' : '/private/api';
    case APIServiceEnum.NOTIFICATION_SERVICE:
      return '/notification-service/api';
    case APIServiceEnum.DEFAULT_SERVICE:
    default:
      return '/private/api';
  }
}
